// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridBackSideConfiguration.jsx"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filters component
 */
!(function() {
  var FieldContainer = require('../FieldContainers/Izenda.FieldContainer');
  var Input = require('share/components/controls/Izenda.Input');
  var CustomCheckbox = require('share/components/controls/Izenda.CustomCheckbox');
  var ReportPartTitle = require('../FieldContainers/Izenda.ReportPartTitle');
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var connect = require('share/enhancers/Izenda.Connect');

  var constants = require('logic/data/Izenda.ReportPartGridConstants');
  var MAXIMUM_FIELD = constants.MAXIMUM_FIELD;
  var GRID_STYLES = constants.GRID_STYLES;
  var REPORT_PART_MODE = require('logic/data/Izenda.ReportBodyConstants').REPORT_PART_MODE;
  const { map, flow } = require('lodash/fp');
  var GRID_STYLES_GROUP_BY_CONTAINER = {
    columns: [GRID_STYLES.VERTICAL, GRID_STYLES.PIVOT],
    rows: [GRID_STYLES.HORIZONTAL, GRID_STYLES.PIVOT],
    values: [GRID_STYLES.PIVOT, GRID_STYLES.DRILL_DOWN],
    groups: [GRID_STYLES.DRILL_DOWN]
  };

  var React = require('react');
  var observer = require('mobx-react').observer;

  var LABEL_CLASS = 'label-column col-md-3';
  var INPUT_CLASS = 'input-column col-md-9';

  var ReportPartGridBackSideConfiguration = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
      reportPart: React.PropTypes.object
    },

    getInitialState: function() {
      return {
        showTitleSettingPopup: false,
        showDescriptionSettingPopup: false
      };
    },

    getFontSettings: function(settings) {
      var font = settings.font;
      var alignment = settings.alignment.alignment;

      return {
        fontFamily: font.family,
        fontSize: font.size,
        fontBold: font.bold,
        fontItalic: font.italic,
        fontUnderline: font.underline,
        fontColor: font.color,
        fontHighlightColor: font.highlightColor,
        alignment: alignment
      };
    },

    render: function() {
      var localization = this.props.localization;
      var reportPart = this.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      var useSeparator = reportPartContent.properties.grouping.useSeparator;
      var gridStyle = reportPartContent.properties.generalInfo.gridStyle;
      var havingColumns = map('value', GRID_STYLES_GROUP_BY_CONTAINER.columns).indexOf(gridStyle) >= 0;
      var havingRows = map('value', GRID_STYLES_GROUP_BY_CONTAINER.rows).indexOf(gridStyle) >= 0;
      var havingValues = map('value', GRID_STYLES_GROUP_BY_CONTAINER.values).indexOf(gridStyle) >= 0;
      var havingGroups = map('value', GRID_STYLES_GROUP_BY_CONTAINER.groups).indexOf(gridStyle) >= 0;
      var isPivot = GRID_STYLES.PIVOT.value === gridStyle;
      var store = this.props.store;
      var maximumField = isPivot ? MAXIMUM_FIELD.PIVOT.LABEL : null;

      var updatePreviewData = function() {
        reportPart.shouldUpdatePreview && store.needUpdatePreview();
      };

      return (
        <GridLayout className="izenda-ReportPartConfiguration">
          <ReportPartTitle mode={REPORT_PART_MODE.CONFIG} reportPart={reportPart} />

          {havingColumns && (
            <div className="row form-group">
              <div className={LABEL_CLASS}>
                <div className="row">
                  <div className="col-md-12">{localization.getText('REPORTDESIGNER_LABEL_COLUMNS')}</div>
                  {isPivot && (
                    <section>
                      <div className="col-md-12">
                        <div className="checkbox">
                          <label>
                            <Input
                              type="checkbox"
                              checked={reportPartContent.columns.properties.addSideTotal}
                              onChange={notifyChange(
                                flow(
                                  reportPartContent.updateColumnsAddSideTotal.bind(reportPartContent),
                                  updatePreviewData
                                ),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            {localization.getText('REPORTDESIGNER_LABEL_ADD_SIDE_TOTAL')}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="checkbox">
                          <label>
                            <Input
                              type="checkbox"
                              checked={reportPartContent.columns.properties.useExpanders}
                              onChange={notifyChange(
                                reportPartContent.updateColumnsUseExpanders.bind(reportPartContent),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            {localization.getText('REPORTDESIGNER_LABEL_USE_EXPANDERS')}
                          </label>
                        </div>
                      </div>
                    </section>
                  )}
                </div>
              </div>
              <div className={INPUT_CLASS}>
                <FieldContainer {...this.props} container={reportPartContent.columns} maximumField={maximumField} />
              </div>
            </div>
          )}

          {havingRows && (
            <div className="row form-group">
              <div className={LABEL_CLASS}>
                <div className="row">
                  <div className="col-md-12">{localization.getText('REPORTDESIGNER_LABEL_ROWS')}</div>
                  {isPivot && (
                    <div className="col-md-12">
                      <div className="checkbox">
                        <label>
                          <Input
                            type="checkbox"
                            checked={reportPartContent.rows.properties.useExpanders}
                            onChange={notifyChange(
                              flow(
                                reportPartContent.updateRowsUseExpanders.bind(reportPartContent),
                                updatePreviewData
                              ),
                              EventsUtils.CHECKBOX
                            )}
                          />
                          {localization.getText('REPORTDESIGNER_LABEL_USE_EXPANDERS')}
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={INPUT_CLASS}>
                <FieldContainer {...this.props} container={reportPartContent.rows} />
              </div>
            </div>
          )}

          {havingGroups && (
            <div className="row form-group">
              <div className={LABEL_CLASS}>
                <div className="col-md-12 row">{localization.getText('REPORTDESIGNER_LABEL_GROUPS')}</div>
              </div>
              <div className={INPUT_CLASS}>
                <FieldContainer {...this.props} container={reportPartContent.rows} />
              </div>
            </div>
          )}

          {havingValues && (
            <div className="row form-group">
              <div className={LABEL_CLASS}>
                <div className="col-md-12 row">{localization.getText('REPORTDESIGNER_LABEL_VALUES')}</div>
              </div>
              <div className={INPUT_CLASS}>
                <FieldContainer {...this.props} container={reportPartContent.values} />
              </div>
            </div>
          )}

          {useSeparator && (
            <div className="row form-group">
              <div className={LABEL_CLASS}>
                <div className="col-md-12 row">{localization.getText('REPORTDESIGNER_LABEL_SEPARATORS')}</div>
              </div>
              <div className={INPUT_CLASS}>
                <FieldContainer {...this.props} container={reportPartContent.separators} />
              </div>
            </div>
          )}
        </GridLayout>
      );
    }
  });

  module.exports = connect()(ReportPartGridBackSideConfiguration);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.ReportPartGridBackSideConfiguration.jsx